import {
    createReducer,
  } from "@reduxjs/toolkit";
  
  
  const STORAGE_KEY =
    "yaman-mobile-meal-columns";
  
  
  const getSavedColumns = () => {
    try {
      if (
        typeof window ===
        "undefined"
      ) {
        return "two";
      }
  
      const saved =
        localStorage.getItem(
          STORAGE_KEY
        );
  
      if (
        saved === "one" ||
        saved === "two"
      ) {
        return saved;
      }
  
      return "two";
    } catch (error) {
      return "two";
    }
  };
  
  
  const initialState = {
    /*
     * الوضع الافتراضي
     * للهاتف = عمودان
     */
    mobileMealColumns:
      getSavedColumns(),
  };
  
  
  const LayoutReducer =
    createReducer(
      initialState,
      (builder) => {
        builder.addCase(
          "set_mobile_meal_columns",
          (
            state,
            action
          ) => {
            state.mobileMealColumns =
              action.payload;
          }
        );
      }
    );
  
  
  export default LayoutReducer;